export type Theme = 'auto' | 'light' | 'dark';

export function getTheme(): Theme {
  try {
    return (localStorage.getItem('nw-theme') as Theme | null) ?? 'auto';
  } catch {
    return 'auto';
  }
}

export function applyTheme(t: Theme = getTheme()): void {
  const r = document.documentElement;
  if (t === 'auto') r.removeAttribute('data-theme');
  else r.setAttribute('data-theme', t);
}

export function toggleTheme(): Theme {
  const cur = document.documentElement.getAttribute('data-theme') ?? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  const next: Theme = cur === 'dark' ? 'light' : 'dark';
  try {
    localStorage.setItem('nw-theme', next);
  } catch {
    /* private mode */
  }
  applyTheme(next);
  return next;
}
